// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7016) return "static/chunks/7016.8f66784641468c30.js";
	if (chunkId === 8223) return "static/chunks/8223.07a31b80931bc3b3.js";
	if (chunkId === 918) return "static/chunks/918.d70fa4a78ee1755d.js";
	if (chunkId === 2859) return "static/chunks/ddfb33c7.5a4984c6744913ee.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6898 ? "c6fea8cc" : chunkId) + "-" + {"357":"78be326338516dca","1441":"e59be6da8d513ba4","1723":"33518976e629c578","3949":"fc8c708a9ceb1dd7","4954":"310208e48e046ea2","5489":"7664a9881a8411c2","6582":"345d9fa3aeeb31af","6898":"65d2f90ae3e639ff","9096":"87b2be63506b0b67"}[chunkId] + ".js";
};